export const toWSNumberWithCommas = (value: string | number) => {
  const number = Math.floor(Number(value));

  if (isNaN(number)) {
    return value;
  }

  return number.toLocaleString("en-US");
};
